import { translations } from '@tools/translations/translations';

/**
 * @description Toggle content utility, if text height > toggleHeight.
 * html structure needed :
 * .content-toggle
 * --> .content-toggle__container
 * --> .content-toggle__btn
 * @param contentToToggle DomElement
 * @param toggleHeight int
 */
export const contentToggle = (contentToToggle, toggleHeight) => {
  /**
   * createToggleBtn
   * @description create toggle button using trad.
   * @returns {Element}
   */
  function createToggleBtn() {
    const toggleBtn = document.createElement('a');
    toggleBtn.classList.add('content-toggle__btn');
    toggleBtn.classList.add('btn-link');
    toggleBtn.innerText = translations.messages['global.read_more'];
    return toggleBtn;
  }

  /**
   * toggleContent
   * @description Set toggle behavior.
   */
  function toggleContent() {
    const contentContainer = contentToToggle.querySelector(
      '.content-toggle__container',
    );

    if (contentContainer.clientHeight > toggleHeight) {
      if (!contentToToggle.classList.contains('active')) {
        contentToToggle.classList.add('active');
      }

      if (!contentToToggle.querySelector('.content-toggle__btn')) {
        const contentBtn = createToggleBtn();
        contentToToggle.appendChild(contentBtn);

        contentBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (!contentToToggle.classList.contains('active')) {
            contentToToggle.querySelector('.content-toggle__container').scrollIntoView();
            contentBtn.innerText = translations.messages['global.read_more'];
          } else {
            contentBtn.innerText = translations.messages['global.read_less'];
          }
          contentToToggle.classList.toggle('active');
        });
      }

      contentContainer.addEventListener('click', (e) => {
        e.preventDefault();
        if (contentToToggle.classList.contains('active')) {
          contentToToggle.classList.remove('active');
          const btn = contentToToggle.querySelector('.content-toggle__btn');
          if (btn) {
            btn.innerText = translations.messages['global.read_less'];
          }
        }
      });
    }
  }

  if (contentToToggle) {
    toggleContent();
  }
};
